import { t } from '@lingui/macro';

import Panel from '../../page-framework/panel/PanelDecorator';
import {
    PANEL_CATEGORIES,
    PANEL_PRIORITIES,
    STATUS_CHART_PANEL_PREVIEW_IMAGE,
} from '../../page-framework/panel/PanelRegistry';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import StatusChartPanel from '../status-chart-panel/StatusChartPanel';
import { entityType } from '../../filters/server-filter/ServerFilter';
import { timeRangeFilterId, virtualMachineFilterId } from '../../filters';

const title = t`Virtual Machine Status`;

function VirtualMachineStatusPanel() {
    return <StatusChartPanel entityType={entityType} />;
}

VirtualMachineStatusPanel.propTypes = {
    ...panelPropTypes,
};

VirtualMachineStatusPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    contentHeight: 40,
    minContentHeight: 40,
    disableVerticalResize: true,
};

export default Panel({
    typeAlias: 'VmwareVmStatusTrend',
    catalogEntry: {
        category: PANEL_CATEGORIES.VIRTUAL_MACHINE,
        priority: PANEL_PRIORITIES.STATUS,
        title,
        description: t`Status trend for a selected virtual machine (VM)`,
        previewImage: STATUS_CHART_PANEL_PREVIEW_IMAGE,
        ipm: true,
    },
    filters: {
        required: [timeRangeFilterId, virtualMachineFilterId],
        optional: [],
    },
})(VirtualMachineStatusPanel);
